import { render, staticRenderFns } from "./MobileCulturalCustomDetail.vue?vue&type=template&id=ad7f03da&scoped=true&"
import script from "./MobileCulturalCustomDetail.vue?vue&type=script&lang=js&"
export * from "./MobileCulturalCustomDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileCulturalCustomDetail.vue?vue&type=style&index=0&id=ad7f03da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7f03da",
  null
  
)

export default component.exports